import { Price } from "@/types/sales";
import { Flex, Input, Table, Tooltip } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDataList from "@/hooks/useDataList";
import api from "@/apis/price";
import { CommonListParams } from "@/types/common";
import { TableWrap } from "../../style";
import usePriceColumn from "./hooks/usePriceColumn";

const SalesPrice: FC = () => {
  const { t } = useTranslation();

  const [list, total, listLoading, { fetchList }] = useDataList<Price, [CommonListParams<string>]>({ fetchApi: api.list });

  const [keyword, setKeyword] = useState<string>("");
  const [current, setCurrent] = useState<number>(1);
  const columns = usePriceColumn()

  useEffect(() => {
    fetch("", 0, 10);
  }, []);

  const fetch = (keyword: string, offset: number, take: number) => {
    fetchList({
      body: keyword,
      pagination: { offset, take },
    }).catch((err) => {
      switch (err) {
        case 10010:
          break;
        default:
          break;
      }
    });
  };

  return (
    <TableWrap>
      <Flex style={{ width: "100%", marginBottom: 20 }} justify="end">
        <Tooltip title={t("sale.bySearch")}>
          <Input.Search
            placeholder={t("sale.bySearch")}
            style={{ width: 200 }}
            value={keyword}
            enterButton
            onChange={(e) => setKeyword(e.target.value.trim())}
            onSearch={(e) => fetch(e, 0, 10)}
          />
        </Tooltip>
      </Flex>
      <Table
        loading={listLoading}
        bordered
        dataSource={list}
        columns={columns}
        pagination={{
          total,
          pageSize: 10,
          current,
          onChange: (page: number, pageSize: number) => {
            fetch(keyword, (page - 1) * 10, pageSize);
            setCurrent(page);
          },
        }}
        scroll={{ x: 3000 }}
        size="small"
      />
    </TableWrap>
  );
};

export default SalesPrice;
